import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";

export const reportListColumn = (isReadOnly) => ([
    {
        field: "transactionId",
        headerName: "Transaction ID",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value, id }) => (
            <>
                {isReadOnly ? value : <Link underline="none" component={RouterLink} to={`/transactions/${id}`}>
                    {value}
                </Link>}
            </>
        ),
    },
    {
        field: "userEmail",
        headerName: "Email ID",
        flex: 0.7,
        minWidth: 150,
        renderCell: ({ value }) => (
            <Tooltip title={value || 'N/A'} placement="top">
                <span>{value || 'N/A'}</span>
            </Tooltip>
        ),
    },
    {
        field: "tagId",
        headerName: "Tag",
        flex: 0.7,
        minWidth: 150,
        renderCell: ({ value }) => (
            <Tooltip title={value || 'N/A'} placement="top">
                <span>{value || 'N/A'}</span>
            </Tooltip>
        ),
    },
    {
        field: "startTime",
        headerName: "Start Time",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
                <span>{yearFirstDateTimeFormat(value)}</span>
            </Tooltip>
        ),
    },
    {
        field: "stopTime",
        headerName: "Stop Time",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
                <span>{yearFirstDateTimeFormat(value)}</span>
            </Tooltip>
        ),
    },
    {
        field: "chargeboxId",
        headerName: "Charger Box",
        flex: 0.5,
        minWidth: 100,
        renderCell: ({ value }) => (
            <Tooltip title={value} placement="top">
                <span>{value}</span>
            </Tooltip>
        ),
    },
    {
        field: "connectorId",
        headerName: "Connector ID",
        flex: 0.5,
        minWidth: 105,
    },
    {
        field: "startValue",
        headerName: "Start Value",
        flex: 0.5,
        minWidth: 95,
    },
    {
        field: "stopValue",
        headerName: "Stop Value",
        flex: 0.5,
        minWidth: 95,
    },
    {
        field: "totalEnergy",
        headerName: "Total Energy Consumed",
        flex: 0.7,
        minWidth: 105,
    },
    {
        field: "paymentType",
        headerName: "Transaction Method",
        flex: 0.5,
        minWidth: 100,
    },
    {
        field: "teamName",
        headerName: "Team Name",
        flex: 0.6,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={value} placement="top">
                <span>{value}</span>
            </Tooltip>
        ),
    },
    {
        field: "gstNumber",
        headerName: "GST Number",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={value || "URP"} placement="top">
                <span>{value || "URP"}</span>
            </Tooltip>
        ),
    },
    {
        field: "amountPaid",
        headerName: "Amount Paid",
        flex: 0.5,
        minWidth: 100,
    },
    {
        field: "chargingCost",
        headerName: "Transaction Cost",
        flex: 0.5,
        minWidth: 100,
    },
    {
        field: "cmCommission",
        headerName: "ZT Commission",
        flex: 0.5,
        minWidth: 120,
    },
    {
        field: "payoutWithTax",
        headerName: "Payout With GST",
        flex: 0.5,
        minWidth: 100,
    },
    {
        field: "payoutWithoutTax",
        headerName: "Payout Without GST",
        flex: 0.5,
        minWidth: 120,
    },
    {
        field: "status",
        headerName: "Payout Status",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={value} placement="top">
                <span>{value}</span>
            </Tooltip>
        ),
    }
]);

export const reportTabListToShow = () => ([
    "transactionId",
    "userEmail",
    "chargeboxId",
    "connectorId",
    "startValue",
    "stopValue",
    "totalEnergy",
    "paymentType",
    "teamName",
    "gstNumber",
    "amountPaid",
    "chargingCost",
    "cmCommission",
    "ztCommission",
    "payoutWithTax",
    "payoutWithoutTax",
    "status",
])

export const reportStatusList = [
    'AUTHORIZED',
    'PAYOUTPENDING',
    'PAYOUTCALCULATED',
    'PAYOUTCOMPLETED',
    'CAPTURED'
];
